module.exports = __webpack_public_path__ + "static/media/ehms-pic4.25faf818.gif";